// Pure campus-time focus selector. No network or account data access.
const TZ = "Asia/Shanghai";
export function campusDateKey(value) {
  const d = new Date(value);
  if (!Number.isFinite(d.getTime())) return "";
  const p = new Intl.DateTimeFormat("en-US", { timeZone: TZ, year: "numeric", month: "2-digit", day: "2-digit" }).formatToParts(d);
  const v = (key) => p.find((x) => x.type === key)?.value || "00";
  return `${v("year")}-${v("month")}-${v("day")}`;
}
export function campusTimeLabel(value) {
  const d = new Date(value);
  if (!Number.isFinite(d.getTime())) return "";
  return new Intl.DateTimeFormat("en-GB", { timeZone: TZ, hour: "2-digit", minute: "2-digit", hourCycle: "h23" }).format(d);
}
export function selectFocus(items, now) {
  const timestamp = new Date(now).getTime();
  if (!Number.isFinite(timestamp)) return null;
  return items.flatMap((item) => {
    const startMs = new Date(item.start).getTime();
    if (!Number.isFinite(startMs)) return [];
    const endMs = item.end ? new Date(item.end).getTime() : startMs + 60 * 60000;
    return endMs > timestamp ? [{ ...item, startMs, endMs }] : [];
  }).sort((a, b) => {
    const aCurrent = a.startMs <= timestamp ? 0 : 1;
    const bCurrent = b.startMs <= timestamp ? 0 : 1;
    return aCurrent - bCurrent || a.startMs - b.startMs || a.endMs - b.endMs;
  })[0] || null;
}
export function summarizeFocus({ items = [], tasks = [], now, complete = true }) {
  const moment = new Date(now), ms = moment.getTime(), today = campusDateKey(moment);
  const remainingEvents = items.filter((item) => {
    const begin = new Date(item.start).getTime();
    const end = item.end ? new Date(item.end).getTime() : begin + 60 * 60000;
    return Number.isFinite(begin) && campusDateKey(item.start) === today && end > ms;
  }).length;
  return { remainingEvents, incompleteTasks: tasks.filter((task) => !task.done).length,
    complete, focus: complete ? selectFocus(items, moment) : null };
}
